export default __webpack_public_path__ + "static/media/revealed6.aa69fbee.png";